import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { BsArrowDownRight, BsArrowUpRight } from "react-icons/bs";
import { Column } from "@ant-design/plots";
import { Table } from "antd";
import { getAllRates, updateRates } from "../features/dailymetalrate/dailymetalrateSlice";
import { getDashboard } from "../features/dashboard/dashboardSlice";

const Dashboard = () => {

  const dispatch = useDispatch();
  const { metalRates, isLoading, isError, message } = useSelector((state) => state.metalRate);
  const { dashboard } = useSelector((state) => state.dashboard);

  const [goldRate, setGoldRate] = useState("");
  const [silverRate, setSilverRate] = useState("");
  const [platinumRate, setPlatinumRate] = useState("");

  // useEffect(() => {
  //   dispatch(getAllRates());
  // }, [dispatch]);

  useEffect(() => {
    console.log("Dispatching getAllRates...");
    dispatch(getAllRates());
    dispatch(getDashboard());
  }, [dispatch]);

  
  // useEffect(() => {
  //   if (metalRates && metalRates.length > 0) {
  //     const gold = metalRates.find(rate => rate.metal === "Gold");
  //     const silver = metalRates.find(rate => rate.metal === "Silver");
  //     const platinum = metalRates.find(rate => rate.metal === "Platinum");

  //     if (gold) setGoldRate(gold.rate);
  //     if (silver) setSilverRate(silver.rate);
  //     if (platinum) setPlatinumRate(platinum.rate);
  //   }
  // }, [metalRates]);

  // useEffect(() => {
  //   console.log("Hiiiiiii",metalRates)
  //   if (metalRates?.data) {
  //     setGoldRate(metalRates.data.gold || "");
  //     setSilverRate(metalRates.data.silver || "");
  //     setPlatinumRate(metalRates.data.platinum || "");
  //   }
  // }, [metalRates]);

  useEffect(() => {
    console.log("Metal Rates from Redux:", metalRates); // Debugging line
    console.log("Metal Rates:", dashboard.recentEnquiries); 
    if (metalRates) {
      setGoldRate(metalRates.gold || "");
      setSilverRate(metalRates.silver || "");
      setPlatinumRate(metalRates.platinum || "");
    }
  }, [metalRates]);

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (isError) {
    return <div>Error: {message}</div>;
  }

  const stats = dashboard?.stats || {};
  const recentEnquiries = dashboard?.recentEnquiries || [];
  const last10Products = dashboard?.last10Products || [];
  const todaysReviews = dashboard?.todaysReviews || [];

  const enquiryColumns = [
    {
      title: "SNo",
      dataIndex: "key",
    },
    {
      title: "Name",
      dataIndex: "name",
    },
    {
      title: "Email",
      dataIndex: "email",
    },
    {
      title: "Subject",
      dataIndex: "subject",
    },
    // {
    //   title: "Total Amount",
    //   dataIndex: "totalAmount",
    // },
  ];

  const enquiryData = recentEnquiries.map((enquiry, index) => ({
    key: index + 1,
    name: enquiry.name,
    email: enquiry.email,
    subject: enquiry.subject,
  }));

  const productColumns = [
    {
      title: "SNo",
      dataIndex: "key",
    },
    {
      title: "Product Name",
      dataIndex: "product_name",
    },
    {
      title: "Category",
      dataIndex: "category",
    },
    {
      title: "Price",
      dataIndex: "price",
    },
    {
      title: "Average Rating",
      dataIndex: "averageRating",
    },
  ];

  const productData = last10Products.map((product, index) => ({
    key: index + 1,
    product_name: product.product_name,
    category: product.category,
    price: product.price,
    averageRating: product.averageRating,
  }));

  const productReviews = [
    {
      title: "SNo",
      dataIndex: "key",
    },
    {
      title: "Product Name",
      dataIndex: "productName",
    },
    {
      title: "User Name",
      dataIndex: "userName",
    },
    {
      title: "Ratings",
      dataIndex: "rating",
    },
    {
      title: "Comments",
      dataIndex: "comment",
    },
  ];

  const ReviewsData = todaysReviews.map((review, index) => ({
    key: index + 1,
    productName: review.productId.product_name,
    userName: review.userId.name,
    rating: review.rating,
    comment: review.comment,
  }));
  

  // const handleSave = () => {
  //   // Handle save logic here
  //   console.log("Gold Rate:", goldRate);
  //   console.log("Silver Rate:", silverRate);
  //   console.log("Platinum Rate:", platinumRate);
  // };

  // const handleSave = () => {
  //   const updatedRates = {
  //     gold_rate: goldRate || metalRates.gold,
  //     silver_rate: silverRate || metalRates.silver,
  //     platinum_rate: platinumRate || metalRates.platinum,
  //   };
  
  //   console.log("Updating Metal Rates:", updatedRates);
  //   dispatch(updateRates(updatedRates));
  // };

  const handleSave = () => {
    const rates = {
      gold_rate: goldRate,
      silver_rate: silverRate,
      platinum_rate: platinumRate,
    };
    dispatch(updateRates(rates));
  };
  

  const data = [
    {
      type: "Jan",
      sales: 38,
    },
    {
      type: "Feb",
      sales: 52,
    },
    {
      type: "Mar",
      sales: 61,
    },
    {
      type: "Apr",
      sales: 145,
    },
    {
      type: "May",
      sales: 48,
    },
    {
      type: "Jun",
      sales: 38,
    },
    {
      type: "July",
      sales: 38,
    },
    {
      type: "Aug",
      sales: 38,
    },
    {
      type: "Sept",
      sales: 38,
    },
    {
      type: "Oct",
      sales: 38,
    },
    {
      type: "Nov",
      sales: 38,
    },
    {
      type: "Dec",
      sales: 38,
    },
  ];
  const config = {
    data,
    xField: "type",
    yField: "sales",
    color: ({ type }) => {
      return "#ffd333";
    },
    label: {
      position: "middle",
      style: {
        fill: "#FFFFFF",
        opacity: 1,
      },
    },
    xAxis: {
      label: {
        autoHide: true,
        autoRotate: false,
      },
    },
    meta: {
      type: {
        alias: "Month",
      },
      sales: {
        alias: "Income",
      },
    },
  };
  return (
    <div>
      <h3 className="mb-4 title">Dashboard</h3>
      <div className="mt-4 mb-5">
        <h3 className="mb-4 title">Add New Data</h3>
        <div className="d-flex gap-3">
          <div className="flex-grow-1 d-flex flex-column">
            <h6>Gold Rate (Per Gram)</h6>
            <input
              type="text"
              className="form-control"
              placeholder="Enter Today's Gold Rate"
              value={goldRate}
              onChange={(e) => setGoldRate(e.target.value)}
            />
          </div>
          <div className="flex-grow-1 d-flex flex-column">
            <h6>Silver Rate (Per Gram)</h6>
            <input
              type="text"
              className="form-control"
              placeholder="Enter Today's Silver Rate"
              value={silverRate}
              onChange={(e) => setSilverRate(e.target.value)}
            />
          </div>
          <div className="flex-grow-1 d-flex flex-column">
            <h6>Platinum Rate (Per Gram)</h6>
            <input
              type="text"
              className="form-control"
              placeholder="Enter Today's Platinum Rate"
              value={platinumRate}
              onChange={(e) => setPlatinumRate(e.target.value)}
            />
          </div>
          <button className="btn btn-primary align-self-end" onClick={handleSave}>
            Save
          </button>
        </div>
      </div>
      <div className="d-flex justify-content-between align-items-center gap-3">
        <div className="d-flex justify-content-between align-items-end flex-grow-1 bg-white p-3 roudned-3">
          <div>
            <p className="desc">Total Products</p>
            <h4 className="mb-0 sub-title">{stats.totalProducts || 0}</h4>
          </div>
          <div className="d-flex flex-column align-items-end">
            <h6>
              {/* <BsArrowDownRight /> 32% */}
            </h6>
            {/* <p className="mb-0  desc">Compared To April 2022</p> */}
          </div>
        </div>
        <div className="d-flex justify-content-between align-items-end flex-grow-1 bg-white p-3 roudned-3">
          <div>
            <p className="desc">Total Enquiries </p>
            <h4 className="mb-0 sub-title">{stats.totalEnquiries || 0}</h4>
          </div>
          <div className="d-flex flex-column align-items-end">
            <h6 className="red">
              {/* <BsArrowDownRight /> 32% */}
            </h6>
            {/* <p className="mb-0  desc">Compared To April 2022</p> */}
          </div>
        </div>
        <div className="d-flex justify-content-between align-items-end flex-grow-1 bg-white p-3 roudned-3">
          <div>
            <p className="desc">Today Enquiries</p>
            <h4 className="mb-0 sub-title">{stats.todayEnquiries || 0}</h4>
          </div>
          <div className="d-flex flex-column align-items-end">
            <h6 className="green">
              {/* <BsArrowDownRight /> 32% */}
            </h6>
            {/* <p className="mb-0 desc">Compared To April 2022</p> */}
          </div>
        </div>
        <div className="d-flex justify-content-between align-items-end flex-grow-1 bg-white p-3 roudned-3">
          <div>
            <p className="desc">Total Customers</p>
            <h4 className="mb-0 sub-title">{stats.totalCustomers || 0}</h4>
          </div>
          <div className="d-flex flex-column align-items-end">
            <h6>
              {/* <BsArrowDownRight /> 32% */}
            </h6>
            {/* <p className="mb-0  desc">Compared To April 2022</p> */}
          </div>
        </div>
      </div>
      {/* <div className="mt-4">
        <h3 className="mb-5 title">Income Statics</h3>
        <div>
          <Column {...config} />
        </div>
      </div> */}
      {/* <div className="mt-4 d-flex gap-4">
        <div className="flex-grow-1">
          <h3 className="title">Recent Orders</h3>
          <div>
            <Table columns={enquiryColumns} dataSource={enquiryData} pagination={false} />
          </div>
        </div>
        <div className="flex-grow-1">
          <h3 className="title">Today’s Reviews</h3>
          <div>
            <Table columns={productColumns} dataSource={productData} pagination={false} />
          </div>
        </div>
      </div> */}
           <div className="mt-4">
        <h3 className="mb-4 title">Recent Enquiries</h3>
        <Table columns={enquiryColumns} dataSource={enquiryData} pagination={false} />
      </div>

      {/* Last 10 Products Table */}
      <div className="mt-4">
        <h3 className="mb-4 title">Last 10 Products</h3>
        <Table columns={productColumns} dataSource={productData} pagination={false} />
      </div>
      <div className="mt-4">
        <h3 className="mb-5 title">Today's Reviews</h3>
        <div>
        {todaysReviews.length > 0 ? (
          // <ul>
          //   {todaysReviews.map((review, index) => (
          //     <li key={index}>{review.comment}</li>
          //   ))}
          // </ul>
          <Table columns={productReviews} dataSource={ReviewsData} pagination={false} />
        ) : (
          <p>No reviews for today.</p>
        )}
        </div>
      </div>
    </div>
  );
};

export default Dashboard;